module.exports = __webpack_public_path__ + "static/media/HERO.79989953.png";